import React from 'react';
import { Link } from 'gatsby';
import Image from 'gatsby-image';
import styled from 'styled-components';

import {
	bpMinSM,
	bpMinLG,
	bpMinXL,
	bpMaxMD,
	// bpMaxLG,
	// bpMinMD,
} from '../utils/breakpoints';

const Container = styled.div`
	font-family: var(--font-heading);

	.desktop-nav-wrapper {
		display: none;
		border-color: var(--color-primary);
	}

	li.nav-item:last-child {
		margin-bottom: 0;
	}

	a.nav-link {
		box-shadow: none;
		font-weight: bold;
		transition: padding 200ms ease 150ms;
	}

	a.nav-link:hover {
		transition: padding 200ms ease 0s;
	}

	a.nav-link-active {
		color: var(--color-primary);
	}

	${bpMinSM} {
		.desktop-nav-wrapper {
			width: 200px;
			display: block;
		}
	}

	${bpMaxMD} {
		.desktop-nav-wrapper {
			width: 100%;
		}

		.author {
			display: none;
		}

		ul {
			display: flex;
			align-items: center;
		}

		li.nav-item {
			margin-bottom: 0;
			margin-right: 30px;
		}
	}

	${bpMinXL} {
		left: -240px;
		position: absolute;

		.desktop-nav-wrapper {
			width: 200px;
		}

		.author {
			display: block;
		}
	}

	${bpMinLG} {
		a.nav-link-active {
			padding-left: 10px;
		}

		a.nav-link:hover {
			padding-left: 10px;
		}
	}
`;

export const MenuItems = ({ location }) => {
	const itemsArray = [
		{ path: '/', key: '', title: 'Home' },
		{ path: '/blog/', key: 'blog', title: 'Blog' },
		{ path: '/books/', key: 'books', title: 'Bookshelf' },
		{ path: '/notes/', key: 'notes', title: 'Notes' },
		{ path: '/about/', key: 'about', title: 'About' },
	];

	return itemsArray.map((item) => {
		const activeItem =
			item.path === location.pathname ||
			item.key === location.pathname.split('/')[1];

		const itemClass = activeItem
			? `nav-link nav-link-active text-lg py-1`
			: `nav-link text-base py-1`;

		return (
			<li key={item.title} className="nav-item">
				<Link to={item.path} className={itemClass}>
					{item.title}
				</Link>
			</li>
		);
	});
};

const Nav = ({ data, location }) => {
	const { author } = data.site.siteMetadata;

	return (
		<Container className="my-8 lg:my-12 xl:my-16">
			<nav
				className="desktop-nav-wrapper lg:py-8 rounded border-1 border-dashed"
				aria-label="Desktop Navigation"
			>
				<section className="author text-center mb-2">
					<Image
						alt={author.name}
						className="author-image"
						fixed={data.avatar.childImageSharp.fixed}
						style={{
							marginBottom: 0,
							minWidth: 80,
							borderRadius: `100%`,
						}}
						imgStyle={{
							borderRadius: `50%`,
						}}
					/>
					<p className="author-name text-sm py-1">
						by <strong>{author.name}</strong>
					</p>
				</section>
				<ul className="list-none m-0 px-6 py-4">
					<MenuItems location={location} />
				</ul>
			</nav>
		</Container>
	);
};

export default Nav;
